<template>
  <v-dialog scrollable persistent v-model="config.status.active" max-width="600">
    <v-card>
      <v-card-text>
        <v-container grid-list-md :class="{ 'px-0': $vuetify.breakpoint.xs }">
          <v-form lazy-validation ref="form" v-model="form.valid">
            <v-row dense justify="center">
              <v-col col="12" class="px-0">
                <v-subheader class="px-2 blue darken-2 white--text font-weight-bold">航空手配</v-subheader>
              </v-col>
              <v-col cols="12">
                <v-combobox v-model="form.flight.status"
                  label="手配しますか？"
                  :items="getFlightStatusItems"
                />
              </v-col>
              <v-col cols="12" class="px-0">
                <v-subheader class="px-2 blue darken-2 white--text font-weight-bold">保険手配</v-subheader>
              </v-col>
              <v-col cols="12">
                <v-combobox v-model="form.insurance.status"
                  label="手配しますか？"
                  :items="getInsuranceStatusItems"
                />
              </v-col>
              <v-col cols="12" class="px-0">
                <v-subheader class="px-2 blue darken-2 white--text font-weight-bold">査証手配</v-subheader>
              </v-col>
              <v-col cols="12">
                <v-combobox v-model="form.visa.status"
                  label="手配しますか？"
                  :items="getVisaStatusItems"
                  @change="changeStatus('visa')"
                />
              </v-col>
              <v-col cols="12" v-if="!['', '不要'].includes(form.visa.status)">
                <v-combobox v-model="form.visa.type" ref="visaType"
                  label="ビザの種類は何ですか？"
                  :items="getVisaTypeItems"
                />
              </v-col>
              <v-col cols="12" v-if="form.visa.status === '当社手配'">
                <v-checkbox v-model="form.visa.local" ref="visaLocal"
                  color="blue darken-2"
                  label="現地で申請する"
                />
              </v-col>
              <v-col cols="12" class="px-0">
                <v-subheader class="px-2 blue darken-2 white--text font-weight-bold">送迎手配</v-subheader>
              </v-col>
              <v-col cols="12">
                <v-combobox v-model="form.pickup.status"
                  label="手配しますか？"
                  :items="getPickupStatusItems"
                  @change="changeStatus('pickup')"
                />
              </v-col>
              <v-col cols="12" v-if="['外部手配', '現地サポーター'].includes(form.pickup.status)">
                <v-text-field v-model="form.pickup.name"
                  ref="pickupName"
                  label="手配先/サポーター名"
                />
              </v-col>
              <v-col cols="12" v-if="form.pickup.status !== '不要'">
                <p class="grey--text text--darken-1 caption text-xs-left">片道ですか往復ですか？</p>
                <v-radio-group v-model="form.pickup.type" ref="pickupType">
                  <v-radio v-for="(item, key) in getPickupTypeItems" :key="key"
                    color="blue darken-2"
                    :label="item"
                    :value="item"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="submit">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'arrangementsModal',
  data () {
    return {
      config: {
        status: {
          active: false
        },
        datepicker: {
          start: false,
          end: false
        }
      },
      meta: {
      },
      form: {
        valid: true,
        id: '',
        flight: {
          status: ''
        },
        insurance: {
          status: ''
        },
        visa: {
          status: '',
          type: '',
          local: ''
        },
        pickup: {
          status: '',
          type: '',
          name: ''
        }
      },
      rules: {
        title: [ v => !!v || '必須項目です' ]
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$emit('done', {
          type: 'arrangements',
          data: this.form
        })
        this.close()
      }
    },
    open: function (values) {
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', values ? {
        valid: true,
        id: values.id ? values.id : ('arrangements_' + new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)),
        flight: {
          status: (values.flight && values.flight.status) ? values.flight.status : ''
        },
        insurance: {
          status: (values.insurance && values.insurance.status) ? values.insurance.status : ''
        },
        visa: {
          status: (values.visa && values.visa.status) ? values.visa.status : '',
          type: (values.visa && values.visa.type) ? values.visa.type : '',
          local: (values.visa && values.visa.local) ? values.visa.local : ''
        },
        pickup: {
          status: (values.pickup && values.pickup.status) ? values.pickup.status : '',
          type: (values.pickup && values.pickup.type) ? values.pickup.type : '',
          name: (values.pickup && values.pickup.name) ? values.pickup.name : ''
        }
      } : {
        valid: true,
        id: ('arrangements_' + new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)),
        flight: {
          status: ''
        },
        insurance: {
          status: ''
        },
        visa: {
          status: '',
          type: '',
          local: ''
        },
        pickup: {
          status: '',
          type: '',
          name: ''
        }
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    changeStatus: function (type) {
      if (type === 'visa') {
        this.$set(this.form, 'visa', {
          status: this.form.visa.status,
          type: this.$refs.visaType ? this.form.visa.type : '',
          local: this.$refs.visaLocal ? this.form.visa.local : ''
        })
      } else if (type === 'pickup') {
        this.$set(this.form, 'pickup', {
          status: this.form.pickup.status,
          type: this.$refs.pickupType ? this.form.pickup.type : '',
          name: this.$refs.pickupName ? this.form.pickup.name : ''
        })
      }
    }
  },
  computed: {
    getFlightStatusItems () {
      return Object.keys(this.$mango.apply.flight.status).map(key => {
        return this.$mango.apply.flight.status[key]
      })
    },
    getInsuranceStatusItems () {
      return Object.keys(this.$mango.apply.insurance.status).map(key => {
        return this.$mango.apply.insurance.status[key]
      })
    },
    getVisaStatusItems () {
      return Object.keys(this.$mango.apply.visa.status).map(key => {
        return this.$mango.apply.visa.status[key]
      })
    },
    getVisaTypeItems () {
      return ['観光', '学生', 'ワーキングホリデー']
    },
    getPickupStatusItems () {
      return Object.keys(this.$mango.apply.pickup.status).map(key => {
        return this.$mango.apply.pickup.status[key]
      })
    },
    getPickupTypeItems () {
      return ['片道', '往復']
    }
  }
}
</script>
